module.exports = __webpack_public_path__ + "static/co-conspirators-51177cbd9207225d11c510fcbd6033aa.jpg";